<div mat-dialog-content [innerHTML]= "data.htmlContent">

</div>
<div mat-dialog-actions class="button-container">
  <button id="confirm" mat-stroked-button [mat-dialog-close]="true"><mat-icon>{{data.icon}}</mat-icon>&nbsp;Modifier le mode de configuration</button>
  <button id="cancel" mat-raised-button color="primary" cdkFocusInitial (click)="onNoClick()"><mat-icon>cancel</mat-icon>&nbsp;Annuler</button>
</div>
